var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'is-pass': _vm.isDueDate, 'is-expiring-soon': _vm.isExpiringSoon}},[_vm._v(_vm._s(_vm.displayDate))])}
var staticRenderFns = []

export { render, staticRenderFns }